




























import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import tabBar from '@/components/home/manageBar.vue'

@Component({
  components: {
    tabBar
  }
})
export default class Main extends Vue {
  uName: string = this.$global.uName
  uPhone: string = this.$global.uPhone
  uLogo: string = this.$global.uLogo
  tabActive: number = 1
  async logoutMethod() {
    const params = {
      token: this.$global.token
    }
    const { error, success } = await this.$store.dispatch('mine/logOut', params)
    if (success && success.code == 200) {
      const wx: any = (window as any).wx
      ;(wx as any).miniProgram.reLaunch({
        url: '/pages/login/login?status=1'
      })
    } else {
      return (this as any).$toast.fail('未知异常')
    }
    console.log(error, success)
  }
}
